module.exports = __webpack_public_path__ + "img/imagen_parrafo_tres.49ec7558.jpg";